(function () {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('[data-mc-review-slider]').forEach(function (root) {
      if (root.dataset.reviewSliderReady) return;
      root.dataset.reviewSliderReady = 'true';
      var track = root.querySelector('[data-mc-reviews-track]');
      var cards = Array.from(track.querySelectorAll('[data-mc-review-candidate]'));
      var controls = root.querySelector('[data-review-controls]');
      var prev = root.querySelector('[data-review-prev]');
      var next = root.querySelector('[data-review-next]');
      if (!cards.length) return;
      track.tabIndex = 0;
      track.setAttribute('aria-label', 'Bewertungen – mit den Pfeiltasten durchblättern');
      var textItems = [];
      cards.forEach(function (card, i) {
        card.hidden = false;
        var text = card.querySelector('.mc-mila-reviews__card-text');
        if (!text) return;
        var button = document.createElement('button');
        text.id = 'review-text-' + root.closest('[id]').id + '-' + i;
        button.type = 'button';
        button.className = 'mc-review-slider__more';
        button.textContent = 'Weiterlesen';
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', text.id);
        text.after(button);
        text.classList.add('mc-review-slider__collapsed');
        button.addEventListener('click', function () {
          var expand = button.getAttribute('aria-expanded') !== 'true';
          button.setAttribute('aria-expanded', String(expand));
          button.textContent = expand ? 'Weniger anzeigen' : 'Weiterlesen';
          text.classList.toggle('mc-review-slider__collapsed', !expand);
        });
        textItems.push({text: text, button: button});
      });
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
        controls.hidden = max <= 2;
      }
      function go(direction) {
        var padding = parseFloat(getComputedStyle(track).paddingLeft) || 0;
        var left = track.getBoundingClientRect().left + padding;
        var index = cards.reduce(function (best, card, i) {
          return Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[best].getBoundingClientRect().left - left) ? i : best;
        }, 0);
        var target = cards[Math.max(0, Math.min(cards.length - 1, index + direction))];
        track.scrollBy({left: target.getBoundingClientRect().left - left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      track.addEventListener('keydown', function (event) {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); go(event.key === 'ArrowRight' ? 1 : -1);
      });
      var frame;
      track.addEventListener('scroll', function () { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, {passive: true});
      function measure() {
        textItems.forEach(function (item) {
          if (item.button.getAttribute('aria-expanded') === 'true') return;
          item.button.hidden = item.text.scrollHeight <= item.text.clientHeight + 2;
        });
        update();
      }
      new ResizeObserver(measure).observe(track);
      document.fonts.ready.then(measure);
      measure();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
